import { gql, useLazyQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils/apolloError";
import { GetAdminPermissions } from "./__generated__/GetAdminPermissions";
import { PERMISSION_FIELDS } from "../fragments/Permission";

export const GET_ADMIN_PERMISSIONS = gql`
  ${PERMISSION_FIELDS}
  query GetAdminPermissions {
    adminPermissions {
      ...PermissionFields
    }
  }
`;

export function useLazyGetAdminPermissions() {
  const [getAdminPermissions, { loading, error, data }] = useLazyQuery<GetAdminPermissions>(GET_ADMIN_PERMISSIONS, {
    errorPolicy: "all",
  });

  return {
    getAdminPermissions,
    data,
    status: { loading, errors: getErrors(error), successful: !error && data ? true : false } as AsyncQueryStatus,
  };
}
